// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__cBP6W","wrapper-nopadding":"wrapper-nopadding__1NaxC","loading":"loading__1xYF1","error":"error__16rrT","table-loading":"table-loading__i1tNz","empty-val":"empty-val__3YArU","panelheader-tools":"panelheader-tools__2kcnK","propsPanels":"propsPanels__2UE-s","new":"new___pcRq","marginLm":"marginLm__2eBLx","marginRm":"marginRm__3mX_5","fullWidth":"fullWidth___G2e8","fullHeight":"fullHeight__2oYqc","noData":"noData__ifO6c","toolbar":"toolbar__3sF09","greeting":"greeting__3EqKj","bordered":"bordered__2zn7m"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Overview/styles.scss
// module id = 2316
// module chunks = 1